// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonToggle_btn__2AMr1"};